// extracted by mini-css-extract-plugin
export default {"input":"ItemInformation_input__+vKUc"};